import { AchPaymentDraftModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../shared';
import { defaultAchPaymentDraftModelDto } from './data/ach.data';

export class AchPaymentDraft extends DomainEntity<AchPaymentDraftModelDto> {
    public createDefault(): this {
        return new AchPaymentDraft(defaultAchPaymentDraftModelDto) as this;
    }

    public get batchName() {
        return this.dto.batchName ?? '';
    }

    public get achCompanyName() {
        return this.dto.achCompanyName ?? '';
    }

    public get secCode() {
        return this.dto.secCode ?? '';
    }

    public get totalDebit() {
        return this.dto.totalDebit ?? 0;
    }

    public get totalCredit() {
        return this.dto.totalCredit ?? 0;
    }

    public get effectiveDate() {
        return this.dto.effectiveDate ?? '0000-00-00';
    }

    public get offsetAccount() {
        return this.offsetAccountName ?? this.offsetAccountNumber;
    }

    public get offsetAccountName() {
        return this.dto.offsetAccountName ?? '';
    }

    public get offsetAccountNumber() {
        return this.dto.offsetAccountNumber ?? '';
    }
}
